var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9123 11.9033H24.5644C23.7463 11.9033 23.083 11.2401 23.083 10.4219C23.083 9.60373 23.7463 8.94047 24.5644 8.94047H31.9123C32.7305 8.94047 33.3937 9.60373 33.3937 10.4219C33.3937 11.2401 32.7305 11.9033 31.9123 11.9033Z",
    fill: "#412A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9119 3.96289H20.8901C20.0719 3.96289 19.4087 3.29963 19.4087 2.48147C19.4087 1.6633 20.0719 1.00004 20.8901 1.00004H31.9119C32.7301 1.00004 33.3933 1.6633 33.3933 2.48147C33.3933 3.29963 32.7301 3.96289 31.9119 3.96289Z",
    fill: "#412A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9118 19.8438H17.4531C16.6349 19.8438 15.9717 19.1805 15.9717 18.3623C15.9717 17.5442 16.6349 16.8809 17.4531 16.8809H31.9118C32.73 16.8809 33.3932 17.5442 33.3932 18.3623C33.3932 19.1805 32.73 19.8438 31.9118 19.8438Z",
    fill: "#412A7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 0.523361C7.68342 0.132837 8.31658 0.132837 8.70711 0.523361L15.0711 6.88732C15.4616 7.27785 15.4616 7.91101 15.0711 8.30154C14.6805 8.69206 14.0474 8.69206 13.6569 8.30154L8 2.64468L2.34315 8.30154C1.95262 8.69206 1.31946 8.69206 0.928933 8.30154C0.538409 7.91101 0.538409 7.27785 0.928933 6.88732L7.29289 0.523361ZM7 24.2305L7 1.23047L9 1.23047L9 24.2305L7 24.2305Z",
    fill: "#412A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingIcon);
export default __webpack_public_path__ + "static/media/ascendingIcon.f3393160e35454b0c5db9e455bcf7ed8.svg";
export { ForwardRef as ReactComponent };